import { QRCodeCanvas } from 'qrcode.react';
import { mascaraCPF } from '@/pages/inscricao/utils';
import { codigoCurto, formatarDataHora, formatarHoraMinuto } from '../utils';
import type { IngressoPedido } from '../types';

interface CartaoIngressoProps {
  ingresso: IngressoPedido;
}

// Ingresso em estilo bilhete: cabeçalho azul com evento e data, QR grande no
// meio e, embaixo, o nome de quem vai usar. Fundo claro para a portaria ler.
export default function CartaoIngresso({ ingresso }: CartaoIngressoProps) {
  const participacao = ingresso.grupo
    ? `${ingresso.participacao} — ${ingresso.grupo}`
    : ingresso.participacao;

  return (
    <div className="overflow-hidden rounded-[22px] bg-background-50 shadow-pcard">
      <div className="bg-primary-500 px-5 py-4 text-center">
        <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-white/80">Ingresso</p>
        <p className="mt-0.5 truncate text-[18px] font-extrabold text-white">{ingresso.evento}</p>
        <p className="mt-0.5 text-[13px] text-white/85">{formatarDataHora(ingresso.evento_em)}</p>
      </div>

      <div className="px-5 py-5">
        <div className="relative flex justify-center">
          <div className="rounded-[18px] border border-background-200 bg-white p-3">
            <QRCodeCanvas
              id={`qr-${ingresso.inscricao_id}`}
              value={ingresso.ingresso}
              size={260}
              bgColor="#ffffff"
              fgColor="#000000"
              level="M"
              marginSize={2}
            />
          </div>
          {ingresso.ja_entrou && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-full -rotate-6 bg-foreground-800/90 py-3 text-center">
                <p className="text-[13px] font-bold tracking-wide text-white">
                  JÁ UTILIZADO
                  {ingresso.entrou_em
                    ? ` — entrou às ${formatarHoraMinuto(ingresso.entrou_em)}`
                    : ''}
                </p>
              </div>
            </div>
          )}
        </div>

        <p className="mt-3 text-center text-[13px] text-foreground-500">
          Aumente o brilho da tela para a portaria ler.
        </p>

        <div className="mt-4 border-t border-dashed border-background-300 pt-4 text-center">
          <p className="truncate text-[16px] font-bold text-foreground-950">{ingresso.portador}</p>
          {ingresso.portador_cpf && (
            <p className="mt-0.5 text-[13px] text-foreground-600">
              CPF {mascaraCPF(ingresso.portador_cpf)}
            </p>
          )}
          {participacao && (
            <p className="mt-0.5 text-[13px] text-foreground-600">{participacao}</p>
          )}
          <p className="mt-1 font-mono text-[11px] text-foreground-400">
            Ingresso · {codigoCurto(ingresso.ingresso)}
          </p>
        </div>
      </div>
    </div>
  );
}